export const iconFontAwesomeUsersPeopleUserXmark = (
	<i className="fa-solid fa-user-xmark"></i>
);
